import {applySpec, find, flow, ifElse, isFilled, toUndefined} from '@logistics-frontend/utils'

import type {PaymentInfoModel} from '../../../model/order/types'
import {paymentMethodGetter, paymentMethodsGetter} from '../../../repo/dcaa/getters/paymentMethods'
import type {PaymentMethodsResponse} from '../../../repo/dcaa/types'

type FIXME_PartialPaymentInfoModel = Pick<PaymentInfoModel, 'methodId' | 'hasDisableReason' | 'type'>
type FIXME_Kind = Pick<PaymentInfoModel, 'kind'>

const getKind = paymentMethodsGetter('selected_method.payment_method_kind')
const getMethods = paymentMethodsGetter('methods')
const isSelected = paymentMethodGetter('is_selected')
const toPartialPaymentInfo: (r: PaymentMethodsResponse) => FIXME_PartialPaymentInfoModel | undefined = flow(
  getMethods,
  find(isSelected),
  ifElse(
    isFilled,
    applySpec<PaymentInfoModel>({
      methodId: paymentMethodGetter('id'),
      hasDisableReason: flow(paymentMethodGetter('display.disable_reason.message'), Boolean),
      type: paymentMethodGetter('details.type'),
    }),
    toUndefined,
  ),
)

export function toPaymentInfo(r: PaymentMethodsResponse): PaymentInfoModel {
  // fixme после переноса SubmitButton, потому что там находятся мапперы из модели в бекенд
  //       это работает очень не правильно, потому что способа оплаты может и не быть в ответе
  const partialPaymentInfo = toPartialPaymentInfo(r)

  return Object.assign<FIXME_Kind, FIXME_PartialPaymentInfoModel | undefined>(
    {
      kind: getKind(r),
    },
    partialPaymentInfo,
  )
}
